<template>
  <div class="index-index-discount">
    <div class="index-discount-wrap">
      <div class="discount-header">
        <div class="top">
          <span class="barge barge-grad">指定{{ queryData.discountActivityType ? "品类" : "商品"  }}满折/满减</span>
          <div class="top-prot">
            <div class="prot-item" v-if="queryData.discountActivityType" @click="onJumpToClassify">
              <span class="color1" v-if="!queryData.goodsList">请选择</span>
              <span v-else>已选择</span>
              <img src="../../assets/image/arrow_icon@2x.png" />
            </div>
            <div class="prot-item" v-else>
              <span class="color2" v-if="!$route.query.id ">创建活动后在满折活动列表管理活动商品</span>
              <span class="color1" v-else>可选商品{{ queryData.canSelectGoodCount }}</span>
            </div>
          </div>
        </div>
        <div class="botm" v-if="$route.query.id && $route.query.type != 'copy'">
          <span class="color1">已参与商品</span>
          <div>
            <p @click="onJumpToGoodsManage" class="color2">
              参与活动的商品，活动发布后不能取消
            </p>
            <i @click="onJumpToGoodsManage">{{ queryData.involvedGoodCount }}</i>
            <img @click="onJumpToGoodsManage" src="../../assets/image/arrow_icon@2x.png" />
          </div>
        </div>
      </div>
      <div class="discount-input">
        <input v-model="queryData.name" maxlength="20" :disabled="queryData.status && queryData.status != 1" placeholder="活动名称，例如三件折上7折" />
      </div>
      <div class="column_view">说明：此名称方便员工查看，不会显示在客户端</div>
      <div :class="{'discount-input':true, 'disabled-color': queryData.status && [2].includes(queryData.status)}" >
        <input v-model="queryData.remark" maxlength="10" :disabled="queryData.status && [2].includes(queryData.status) " placeholder="名称备注，非必填，仅内部可见，最多10个字" />
      </div>
      <div class="discount-time">
        <div :class="{ 'time-none': !queryData.startTime,'disabled-color': queryData.status && queryData.status != 1 }" @click="onDatePickChange(1)">
          {{ queryData.startTime ? queryData.startTime : "开始时间，请选择" }}
        </div>
        <!-- <input v-model="queryData.startTime" readonly="readonly" :disabled="queryData.status && queryData.status != 1" placeholder="开始时间，请选择" @click="onDatePickChange(1)"/> -->
      </div>
      <div class="discount-time">
        <div :class="{ 'time-none': !queryData.endTime,'disabled-color': queryData.status && ![1, 3].includes(queryData.status) }" @click="onDatePickChange(2)">
          {{ queryData.endTime ? queryData.endTime : "结束时间，请选择" }}
          <span class="time-text" v-if="queryData.status && queryData.status && ![1, 3].includes(queryData.status)">
            需暂停活动，才可更改；
          </span>
        </div>
        <!-- <input v-model="queryData.endTime" readonly="readonly" :disabled="queryData.status && queryData.status != 1" placeholder="结束时间，请选择"  /> -->
      </div>
      <div class="discount-date">
        <div class="date-list">
          <span :class="['barge', { 'barge-danger': queryData.timeType == 1 }]" @click="onTimeSet(1, 7)">7天</span>
          <span :class="['barge', { 'barge-danger': queryData.timeType == 2 }]" @click="onTimeSet(2, 15)">15天</span>
          <span :class="['barge', { 'barge-danger': queryData.timeType == 3 }]" @click="onTimeSet(3, 30)">30天</span>
        </div>
        <p class="date-desc">活动时长：{{ timeStr }}</p>
      </div>
      <div class="discount-sale">
        <p class="sale-tt">促销方式</p>
        <div  :class="{'sale-list':true, 'disabled-color': queryData.status && queryData.status != 1}" @click="onSaleModeChange">
          <span :class="['barge', { 'barge-grad': queryData.promotionType == 1 }]" :data-type="1">按件打折</span>
          <span :class="['barge', { 'barge-grad': queryData.promotionType == 2 }]" :data-type="2">按金额打折</span>
          <span :class="['barge', { 'barge-grad': queryData.promotionType == 4 }]" :data-type="4">按件满减</span>
          <span :class="['barge', { 'barge-grad': queryData.promotionType == 3 }]" :data-type="3">按金额满减</span>
        </div>
      </div>
      <DiscountSetting :type="queryData.promotionType" :setType="queryData.setType" :hide="Number(queryData.status) > 2 || queryData.status == 2" :discountLadderSettingList="queryData.discountLadderSettingList" @delete="onPreferDelete" @route="onJumpToPrefer"></DiscountSetting>

      <!-- this.queryData.status && this.queryData.status != 1 && this.$route.query.type != 'copy' -->
      <div :class="{'discount-text':true, 'disabled-color': queryData.status && queryData.status != 1 }" @click="onJumpToAfterSale">
        
        <span v-if="queryData.afterTemplate">
          售后设置：
          {{ afterTemplateOpt[queryData.afterTemplate] || "" }}
          <!-- {{
            queryData.saleAfterMode == 0
              ? "按活动优惠后实付款退款"
              : queryData.saleAfterMode == 1
              ? "不支持退货"
              : ""
          }} -->
        </span>
        <span v-else>
          售后设置：
          <!-- {{ afterTemplateOpt[queryData.afterTemplate] || "" }} -->
          {{
            queryData.saleAfterMode == 0
              ? "按活动优惠后实付款退款"
              : queryData.saleAfterMode == 1
              ? "不支持退货"
              : ""
          }}
        </span>
        <img src="../../assets/image/arrow_icon@2x.png" />
      </div>
      <div :class="{'discount-text':true, 'disabled-color': queryData.status && queryData.status != 1 }" @click="onJumpToMaling" v-if="queryData.promotionType == 1 || queryData.promotionType == 2">
        <span>抹零设置：{{ getLabel(queryData.singleEraseMode) ? "商品尾数" : ""
          }}{{ getLabel(queryData.singleEraseMode)
          }}{{ getLabel(queryData.singleEraseMode) && getLabel(queryData.totalEraseMode) ? ","  : ""
          }}{{ getLabel(queryData.totalEraseMode) ? "总额尾数" : ""
          }}{{ getLabel(queryData.totalEraseMode) }}</span>
        <img src="../../assets/image/arrow_icon@2x.png" />
      </div>
      <div :class="{'discount-text':true, 'disabled-color': queryData.status && queryData.status != 1 }" @click="onJumpToDiscType">
        <span v-if="queryData.promotionType==1 || queryData.promotionType == 2">活动类型：{{
            queryData.discountType == 1
              ? "吊牌价满折活动"
              : queryData.discountType == 2
              ? "折上折"
              : ""
          }}</span>
        <span v-else-if="queryData.promotionType==3 || queryData.promotionType == 4">活动类型：{{
            queryData.discountType == 1
              ? "吊牌价满减活动"
              : queryData.discountType == 2
              ? "销售价满减活动"
              : ""
          }}</span>
        <img src="../../assets/image/arrow_icon@2x.png" />
      </div>
      <!-- 增加 -->
      <div class="discount-text" :class="{'discount-text':true, 'disabled-color': queryData.status && queryData.status != 1 && $route.query.type != 'copy'}" @click="getActivityTemp()">
        <span>活动文案显示:{{ (activityTemplae && activityTemplae.templateName) || '' }}</span>
        <img src="../../assets/image/arrow_icon@2x.png" />
      </div>
      
    </div>
    <FixedBtn label="提交" @btnClick="onActivityOpen"></FixedBtn>
    <activityTemplate ref="activityTemplate" @event-discount="onActivityTemplae"></activityTemplate>

    <van-action-sheet v-model="dateShow">
      <van-datetime-picker v-if="dataType == 1" :min-date="minDate" @confirm="onDatePickConfirm" @cancel="onDatePickCancel" v-model="queryData.startTimeStr" type="datetime"></van-datetime-picker>
      <van-datetime-picker v-if="dataType == 2" :min-date="minDate" @confirm="onDatePickConfirm" @cancel="onDatePickCancel" v-model="queryData.endTimeStr" type="datetime"></van-datetime-picker>
    </van-action-sheet>

    <van-dialog v-model="actShow" title="活动确认" @confirm="onActivityConfirm" show-cancel-button confirm-button-color="#ED3939">
      <div class="act-dialog">
        <p class="tt">{{ queryData.name }}</p>
        <div class="jngd">
          <div class="jngd-tt">
            <span>已参与商品：</span>
            <i>{{ queryData.involvedGoodCount || 0 }}</i>
          </div>
          <p class="jngd-prot">温馨提示：参与活动的商品，活动发布后不能取消</p>
        </div>
        <p class="ts" v-show="queryData.discountType">
          <span v-if="queryData.promotionType==1 || queryData.promotionType == 2">
            {{  queryData.discountType == 1  ? "吊牌价满折活动"  : queryData.discountType == 2 ? "折上折活动" : ""  }}
          </span>
          <span v-else-if="queryData.promotionType==3 || queryData.promotionType == 4">
            {{ queryData.discountType == 1  ? "吊牌价满减活动"  : queryData.discountType == 2  ? "销售价满减活动" : "" }}
          </span>

        </p>
        <p class="desc" v-show="queryData.remark">{{ queryData.remark }}</p>
        <div class="disct">
          <span class="barge barge-danger" v-for="(item, index) in queryData.discountLadderSettingList" :key="index">
            {{(queryData.promotionType==3|| queryData.promotionType == 4) && queryData.setType == 2?'每':''}}满{{item.conditionValue}}{{typeOption[queryData.promotionType-1].val1}}{{queryData.promotionType==3|| queryData.promotionType == 4?'减':''}}{{item.discountValue}}{{typeOption[queryData.promotionType-1].val2}}
          </span>
        </div>
        <div class="sale">
          <p class="sale_1">退款</p>
          <p class="sale_2">
            售后须知：{{ afterTemplateOpt[queryData.afterTemplate] || "" }}
          </p>

          <!-- <p class="sale_2" v-if="queryData.saleAfterMode == 1">
            售后须知：该订单享受活动优惠后不支持退货
          </p>
          <p class="sale_2" v-else>
            售后须知：该订单享受活动优惠后按优惠后实付款退货
          </p> -->
        </div>
        <p class="tm">{{ queryData.startTime }} 至 {{ queryData.endTime }}</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import http from "@/utils/axios";
import PreferItem from "./components/preferItem";
import InputItem from "./components/inputItem";
import DiscountSetting from "./components/discount_setting";
import FixedBtn from "./components/fixed_btn";
import { Toast } from "vant";
import utils from "@/utils/common";
import activityTemplate from "./components/activity_template";
export default {
  name: "discount",
  data() {
    return {
      minDate: new Date(2020, 0, 1),
      queryData: {
        discountActivityType:
          Number(this.$route.query.discountActivityType) || 0,
        promotionType: 1,
        startTime: "",
        startTimeStr: new Date(),
        endTime: "",
        endTimeStr: new Date(),
        // goodsList: 0,
        type: 1,
        configId:'' 
      },
      dataType: 1,
      dateShow: false,
      actShow: false,
      isConfirm: false,
      mlOptions: [
        { value: 0, label: "实收" },
        { value: 1, label: "抹掉个位元" },
        { value: 2, label: "抹掉角" },
        { value: 3, label: "四舍五入到元" },
        { value: 4, label: "进位到元" },
        { value: 5, label: "抹掉分" },
        { value: 6, label: "四舍五入到角" },
        { value: 7, label: "进位到角" },
      ],
      typeOption: [
        { label: "按件打折", key1: "满", val1: "件", key2: "打", val2: "折" },
        { label: "按金额打折", key1: "满", val1: "元", key2: "打", val2: "折" },
        { label: "按金额满减", key1: "满", val1: "元", key2: "减", val2: "元" },
        { label: "按件满减", key1: "满", val1: "件", key2: "减", val2: "元" },
      ],
      activityTemplae:{},
      discountActivityList:[],
      afterTemplateOpt: {}
    };
  },
  created() {
    this.$loading.hide();
    this.getShopBranch()
    this.getAfterTemplate()
    if (this.$route.query.id  && 
    ((this.$route.query.type != 'copy') && !this.$store.state.discount.shopName) ||
    (this.$route.query.type == 'copy' && !(this.$store.state.discount.shopName || this.$store.state.discount.statusString))) {
     return  this.getData();
    }else{
      this.getDiscountActivity();
    }
    if (this.$route.query.brandId && !this.$store.state.discount.branchId) {
      this.queryData.branchId = this.$route.query.brandId;
    }
    Object.assign(this.queryData, this.$store.state.discount);
    if (this.queryData.startTime) {
      this.queryData.startTimeStr = new Date(this.queryData.startTime);
    }
    if (this.queryData.endTime) {

      this.queryData.endTimeStr = new Date(this.queryData.endTime);
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.path != "/discount_setting" &&
      to.path != "/discount_type" &&
      to.path != "/discount_maling"
    ) {
      this.$store.dispatch("clearDiscount");
    }
    next();
  },
  computed: {
    timeStr: function () {
      let date;
      if (this.queryData.startTime && this.queryData.endTime) {
        let startDate = new Date(this.queryData.startTime.replace(/\-/g, "/")).getTime(),
          endDate = new Date(this.queryData.endTime.replace(/\-/g, "/")).getTime();
        let time = (endDate - startDate) / 1000,
          day = Math.floor(time / (24 * 3600)),
          hour = Math.floor((time % (24 * 3600)) / 3600),
          minute = Math.floor((time % 3600) / 60);
        date = `${day}天${hour}小时${minute}分`;
      }

      return date || "";
    },
  },
  methods: {
    getDiscountActivity(configId) {
      http({
        url: "order/config/discountActivity/pageList",
        method: "post",
        parmes: {
          status: 1,
        }
      }).then(rps => {
        this.discountActivityList = rps.data;
        console.log('this.queryData.configId',this.queryData.configId)
        if(!this.$route.query.id){
          // 新增默认选中   默认模板
          if(this.queryData.configId == ''){
            this.activityTemplae = this.discountActivityList.find(item=>{
              return item.isDefault == 1
            })
            this.queryData.configId = this.activityTemplae.id
          }else{
            this.activityTemplae = this.discountActivityList.find(item=>{
            return item.id ==  this.queryData.configId
          })
          }
        
        }else{
          this.activityTemplae = this.discountActivityList.find(item=>{
            return item.id == configId
          })
          console.log('this.activityTemplae',this.activityTemplae)
        }
      });
    },
    getActivityTemp(){
      if (this.queryData.status && this.queryData.status != 1 && this.$route.query.type != 'copy') return;
      this.$refs['activityTemplate'].getShow(this.discountActivityList,this.queryData.configId);
    },
    onActivityTemplae(obj){
      this.activityTemplae =obj;
      this.queryData.configId = obj.id
    },
    getAfterTemplate() {
      http({ url: "/order/admin/branch/afterTemplate", method: "get", }).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.afterTemplateOpt = Object.fromEntries(res.data.map(v => ([v.value, v.desc])))
          
        }
      }).catch(() => {
      });
    },
    getShopBranch() {
      // http({ url: "/order/bee/goods/shopBranch", method: "POST", parmes: {},
      // }).then((rps) => {
      //   console.log(666);
      //   console.log(rps);
      // });
    },
    onJumpToClassify() {
      if (this.queryData.status && this.queryData.status != 1 ) return;
      this.$router.push({
        name: "chooseClassify",
      });
      this.$store.dispatch("saveDiscount", this.queryData);
    },
    onJumpToGoodsManage() {
      let url = window.location.origin + "/h5user/addedGoods?id=" + this.queryData.id + "&status=" + this.queryData.status
      if(this.$route.query.brandId){
        url = url + "&brandId=" + this.$route.query.brandId;
      }
      // if(this.queryData.status && this.queryData.status != 1) return
      utils.jumpToNewPage({
        url,
        noTitle: "1",
      });

      this.$store.dispatch("saveDiscount", this.queryData);
    },
    onJumpToAfterSale() {

      if (this.queryData.status && this.queryData.status != 1 ) return;
      this.$router.push({
        name: "aftersaleSetting",
        query: {
          // saleAfterMode: this.queryData.saleAfterMode,
          afterTemplate: this.queryData.afterTemplate,
        },
      });
      this.$store.dispatch("saveDiscount", this.queryData);
    },
    onJumpToMaling() {
      if (this.queryData.status && this.queryData.status != 1 ) return;
      this.$router.push({
        name: "discount_maling",
        query: {
          singleEraseMode: this.queryData.singleEraseMode,
          totalEraseMode: this.queryData.totalEraseMode,
        },
      });
      this.$store.dispatch("saveDiscount", this.queryData);
    },
    onJumpToDiscType() {
      if (this.queryData.status && this.queryData.status != 1 ) return;
      this.$router.push({
        name: "discount_type",
        query: {
          discountType: this.queryData.discountType,
          promotionType: this.queryData.promotionType
        },
      });
      this.$store.dispatch("saveDiscount", this.queryData);
    },
    onJumpToPrefer() {
      if (this.queryData.status && ![1].includes(this.queryData.status))
        return;
      let query = {
        type: this.queryData.promotionType,
      };
      if (
        this.queryData.discountLadderSettingList &&
        this.queryData.discountLadderSettingList.length > 0
      ) {
        query.discountLadderSettingList = JSON.stringify(
          this.queryData.discountLadderSettingList
        );
        query.setType = this.queryData.setType;
      }
      this.$router.push({
        name: "discount_setting",
        query,
      });
      this.$store.dispatch("saveDiscount", this.queryData);
    },
    getLabel(mode) {
      return (
        (this.mlOptions.find((item) => item.value == mode) &&
          this.mlOptions.find((item) => item.value == mode).label) ||
        ""
      );
    },
    getData() {
      http({
        url: "/order/bees/discountActivity/" + (this.$route.query.id || 1),
        method: "post",
      }).then((rps) => {
        if (rps.code == 200) {
          if (this.$route.query.type == 'copy') {
            // delete rps.data.id
            delete rps.data.involvedGoodCount
            delete rps.data.status
            delete rps.data.saleAfterMode
            if (rps.data.singleEraseMode==0) {
               rps.data.singleEraseMode = 7
            }

          }
          this.queryData = rps.data;
          this.queryData.startTimeStr = new Date(
            this.queryData.startTime.replace(/\-/g, "/")
          );
          this.queryData.endTimeStr = new Date(
            this.queryData.endTime.replace(/\-/g, "/")
          );
          this.getDiscountActivity(this.queryData.configId)
        }
      });
    },
    inputChange(obj) {
      this.queryData[obj.key] = obj.value;
    },
    onPreferDelete(index) {
      this.queryData.discountLadderSettingList.splice(index, 1);
    },
    onDatePickChange(type) {
      if (type == 1 && this.queryData.status && this.queryData.status != 1)
        return;
      if (
        type == 2 &&
        this.queryData.status &&
        ![1, 3].includes(this.queryData.status)
      )
        return;
      if (type == 2 && this.queryData.status == 3) {
        //暂停状态可以编辑结束时间，结束时间不能小于当前系统时间
        this.minDate = new Date(Date.now() + 1000 * 60);
      }
      this.dateShow = !this.dateShow;
      this.dataType = type;
    },
    onDatePickConfirm(val) {
      this.dateShow = !this.dateShow;
      this.queryData.timeType = "";
      if (this.dataType == 1) {
        this.queryData.startTime = this.confirmPicker(val);
      } else {
        this.queryData.endTime = this.confirmPicker(val);
      }
    },
    onDatePickCancel() {
      this.dateShow = !this.dateShow;
      if (this.dataType == 1) {
        this.queryData.startTimeStr =
          (this.queryData.startTime &&
            new Date(this.queryData.startTime.replace(/\-/g, "/"))) ||
          "";
      } else {
        this.queryData.endTimeStr =
          (this.queryData.endTime &&
            new Date(this.queryData.endTime.replace(/\-/g, "/"))) ||
          "";
      }
    },
    onSaleModeChange(e) {
      if (this.queryData.status && this.queryData.status != 1 && this.$route.query.type != 'copy') return;
      let type = e.target.dataset.type;
      if (type && type != this.queryData.promotionType) {
        this.$dialog
          .confirm({
            title: "切换促销方式后，将清空当前的优惠设置",
            message: "是否确定切换",
            confirmButtonColor: "#ED3939",
          })
          .then(() => {
            this.queryData.promotionType = type;
            this.queryData.discountLadderSettingList = [];
            if (type == 3 || type == 4) {
              this.queryData.singleEraseMode = 0;
              this.queryData.totalEraseMode = 0;
            }
          })
          .catch(() => { });
      }
    },
    onActivityConfirm() {
      if (this.isConfirm) return;

      this.isConfirm = true;
      console.log(this.queryData);
      console.log(this.queryData.i);
      if (this.queryData.id) {
        // this.onActivityCopy()
        if (this.$route.query.type == 'copy') {
          this.onActivityCopy()
        } else {
          this.onActivityUpdate();
        }
      } else {
        this.onActivityAdd();
      }
    },
    onActivityCopy() {
      console.log(5566);
      http({
        url: "/order/bees/discountActivity/add",
        method: "post",
        parmes: {
          ...this.queryData,
          branchId: this.$route.query.brandId,
        },
      }).then(async (res) => {
        if (res.code == 200) {
          console.log(res);
          let discountActivityId = res.data

          // utils.nativeMethod({ tm: 1000004, tp: { pageCode: 1 } });
          // utils.goBack();
          // this.isConfirm = false;
          // let url = window.location.origin + '/h5user/addedGoods?id=' + discountActivityId + '&status=' + 1
          // if(this.$route.query.brandId){
          //   url = url + "&brandId=" + this.$route.query.brandId;
          // }
          // utils.jumpToNewPage({
          //   url,
          //   finishPage: '1',
          //   noTitle: '1'
          // })


          let param = {
            discountActivityId: this.$route.query.id,
            goodType: 1,
            pageIndex: 1,
            pageSize: 9999999,
            isInvolved: 'y',
          }
          let goodIds = await http({ url: '/order/bees/discountActivity/goodManagementList', method: 'post', parmes: param })
          Toast.success("添加成功");
          this.isConfirm = false;
          let url = window.location.origin + '/h5user/addedGoods?id=' + discountActivityId + '&status=' + 1
          if(this.$route.query.brandId){
              url = url + "&brandId=" + this.$route.query.brandId;
          }
          if (goodIds.code == 200 && goodIds.data.list.length && (goodIds = goodIds.data.list)) {
            let data = {
              discountActivityId,
              discountGoods: goodIds.map(v => ({ goodId: v.goodId, goodType: 1 }))
            }
            http({ url: '/order/bees/discountActivity/good/add', method: 'put', parmes: data }).then(rps => {
              if (rps.code == 200) {
                utils.nativeMethod({ tm: 1000004, tp: { pageCode: 1 } });
                // utils.goBack();
                utils.jumpToNewPage({
                  url,
                  finishPage: '1',
                  noTitle: '1'
                })
              }
            })
          } else {
            
            utils.nativeMethod({ tm: 1000004, tp: { pageCode: 1 } });
            // utils.goBack();
            this.isConfirm = false;
            utils.jumpToNewPage({
              url,
              finishPage: '1',
              noTitle: '1'
            })
          }
        }
      });
    },
    onActivityAdd() {
      http({
        url: "/order/bees/discountActivity/add",
        method: "post",
        parmes: {
          ...this.queryData,
          branchId: this.$route.query.brandId,
        },
      }).then((res) => {
        if (res.code == 200) {
          Toast.success("添加成功");
          utils.nativeMethod({ tm: 1000004, tp: { pageCode: 1 } });
          // utils.goBack();
          this.isConfirm = false;
          let url = window.location.origin + '/h5user/addedGoods?id=' + res.data + '&status=' + 1
          if(this.$route.query.brandId){
            url = url + "&brandId=" + this.$route.query.brandId;
          }
          utils.jumpToNewPage({
            url,
            finishPage: '1',
            noTitle: '1'
          })
        }
      });
    },
    onActivityUpdate() {
      http({
        url: "/order/bees/discountActivity/update",
        method: "put",
        parmes: {
          ...this.queryData,
        },
      }).then((rps) => {
        if (rps.code == 200) {
          Toast.success("修改成功");
          utils.nativeMethod({ tm: 1000004, tp: { pageCode: 1 } });
          utils.goBack();
          this.isConfirm = false;
        }
      });
    },
    onActivityOpen() {
      console.log(this.queryData, 1111);
      // return
      if (!this.queryData.name) {
        return Toast.fail("活动名称不可为空");
      }
      if (!this.queryData.startTime || !this.queryData.endTime) {
        return Toast.fail("活动起止时间不可为空");
      }
      if (
        !this.queryData.discountLadderSettingList ||
        this.queryData.discountLadderSettingList.length == 0
      ) {
        return Toast.fail("请至少填写一个优惠折扣");
      }
      if (
        this.queryData.promotionType == 1 ||
        this.queryData.promotionType == 2
      ) {
        if (
          this.queryData.singleEraseMode === "" ||
          this.queryData.singleEraseMode === undefined ||
          this.queryData.totalEraseMode === "" ||
          this.queryData.totalEraseMode === undefined
        ) {
          return Toast.fail("请选择抹零设置");
        }
      }

      
      // let _saleAfterMode = this.queryData.saleAfterMode + ''
      // if (!_saleAfterMode || _saleAfterMode=='undefined') {
      // let _saleAfterMode = this.queryData.saleAfterMode + ''
      // if (!_saleAfterMode || _saleAfterMode == 'undefined') {
      //   return Toast.fail("请选择售后设置");
      // }
      // afterTemplate
      let _afterTemplate = this.queryData.afterTemplate + ''
      let _saleAfterMode = this.queryData.saleAfterMode + ''
      if ((!_afterTemplate || _afterTemplate == 'undefined') && (!_saleAfterMode || _saleAfterMode == 'undefined')) {
        return Toast.fail("请选择售后设置");
      }

      if (!this.queryData.discountType) {
        return Toast.fail("请选择活动类型");
      }
      if(!this.queryData.configId){
        return Toast.fail("活动文案模板不可为空");
      }
      

      this.actShow = !this.actShow;
    },
    onTimeSet(type, date) {
      if (this.queryData.status && this.queryData.status != 1) return;
      let startDate = new Date(),
        endDate = new Date();
      endDate.setDate(endDate.getDate() + date);
      endDate.setHours(23);
      endDate.setMinutes(59);
      endDate.setSeconds(59);
      this.queryData.startTimeStr = startDate;
      this.queryData.startTime = this.confirmPicker(startDate);
      this.queryData.endTimeStr = endDate;
      this.queryData.endTime = this.confirmPicker(endDate);
      this.queryData.timeType = type;
    },
    confirmPicker(val) {
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      let seconds = val.getSeconds();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      if (seconds >= 0 && seconds <= 9) {
        seconds = `0${seconds}`;
      }
      return `${year}-${month}-${day} ${hour}:${minute}:${seconds}`;
    },
  },
  components: {
    PreferItem,
    InputItem,
    DiscountSetting,
    FixedBtn,activityTemplate
  },
};
</script>
<style lang="less" scoped>
.column_view {
  // margin-top: 10px;
  font-size: 24px;
  color: #f8a651;
  padding: 10px 30px 0px 30px;
}
.index-index-discount {
  padding-bottom: 130px;
  .barge {
    display: inline-block;
    width: 140px;
    height: 50px;
    line-height: 50px;
    border-radius: 10px;
    border: 2px solid #999;
    color: #999;
    font-size: 24px;
    text-align: center;
    box-sizing: border-box;
    vertical-align: text-top;

    &.barge-danger {
      color: #ed3939;
      background-color: #ffe7e6;
      border-color: #ffe7e6;
    }

    &.barge-grad {
      color: #fff;
      background: linear-gradient(90deg, #ff8200, #ff1414);
      border: none;
    }
  }

  .index-discount-wrap {
    padding-bottom: s40px;
    background-color: #fff;
    .discount-header {
      padding: 30px;
      font-size: 24px;
      border-bottom: 10px solid #f7f7f7;
      border-top: 10px solid #f7f7f7;
      // padding: 0 30px;

      .barge {
        width: 210px;
      }
      .top,
      .botm {
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
          width: 44px;
          height: 44px;
          margin-right: 20px;
        }
        .color1 {
          color: #999999;
        }
        .color2 {
          color: #f8a651;
        }
      }
      .top {
        .top-prot {
          display: flex;
          .prot-item {
            display: flex;
            align-items: center;
          }
        }
      }
      .botm {
        height: 70px;
        margin-top: 20px;
        border-bottom: 1px solid #ddd;

        div {
          display: flex;
          align-items: center;
        }

        i {
          color: #ed3939;
          font-style: normal;
          margin: 0 20px 0 23px;
        }
      }
    }
    .discount-input,
    .discount-time,
    .discount-text {
      height: 129px;
      display: flex;
      align-items: center;
      border-bottom: 2px solid #dddddd;
      margin: 0 30px;

      input,
      div {
        width: 100%;
        height: 33px;
        font-size: 24px;
        border: none;
        background-color: #fff;
      }
    }
    .discount-time,
    .discount-text {
      height: 99px;
      padding: 49px 0 18px;
      box-sizing: border-box;
      margin: 0 30px;
    }
    .discount-time .time-none {
      color: red;
    }
    .discount-date {
      margin: 30px 30px 0;
      .date-list {
        span:not(:last-child) {
          margin-right: 20px;
        }
      }

      .date-desc {
        margin-top: 20px;
        font-size: 24px;
        line-height: 33px;
        color: #999;
      }
    }

    .discount-sale {
      margin: 30px 30px 0;
      .sale-tt {
        font-size: 24px;
        line-height: 33px;
      }
      .sale-list {
        margin: 20px 0 30px;

        span:not(:last-child) {
          margin-right: 20px;
        }
      }
    }
    .discount-text {
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 24px;
      }
      img {
        width: 44px;
        height: 44px;
      }
    }
  }
}

.act-dialog {
  padding: 30px 50px 40px;
  margin-top: 30px;
  border-top: 1px solid #ebedf0;

  .jngd {
    font-size: 24px;
    margin-bottom: 20px;
    line-height: 40px;
    .jngd-prot {
      color: #f8a651;
    }
    .jngd-tt {
      i {
        font-style: normal;
        color: #ed3939;
      }
    }
  }
  .sale {
    font-size: 24px;
    margin-top: 20px;
    line-height: 40px;
    .sale_2 {
      color: #f8a651;
    }
  }
  .tt {
    height: 40px;
    line-height: 40px;
    font-weight: 500;
    font-size: 28px;
    margin-bottom: 20px;
  }
  .ts,
  .desc,
  .tm {
    height: 40px;
    line-height: 40px;
    font-size: 24px;
    color: #666;
  }
  .disct {
    span {
      width: auto;
      margin-right: 20px;
      margin-top: 20px;
      padding: 0 20px;
    }
  }
  .tm {
    color: #999;
    margin-top: 20px;
  }
}
.disabled-color{
  color: #999;
}
.time-text{
  color: #ed3939;
  margin-left: 40px;

}
</style>
